module.exports = __webpack_public_path__ + "static/media/green-leaves-flip.8fd0f124.jpeg";